import '.en{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.eo{padding-left:1.5rem;}.ssr-plugin'
import '.ep{margin:1rem 0;}.ssr-plugin'
import '.eq{color:var(--gray-700);}.ssr-plugin'
import '.er{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="en eo ep eq er"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
